import React from "react";
import classes from "../UI/HeaderCard.module.css";

const HeaderCard = (props) => {
  return <div className={classes.cardMain}>{props.children}</div>;
};

export default HeaderCard;
